import { SContainer } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Pages } from '../../../../../types/offers';
import { setCurrentOfferPage } from '../../../store/offer';
import SettingUp from '../../shared/setting-up';

const SetUp = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentOfferPage(Pages.SettingUp));
  }, []);

  return (
    <main>
      <SContainer>
        <SettingUp />
      </SContainer>
    </main>
  );
};

export default SetUp;
